import { Credentials, CredentialsTitle } from "./types";

export const credentialsTitles: CredentialsTitle = {
  username: "Username",
  password: "Password",
  readOnly: "Token (read only)",
};

export const credentialsKeys = Object.keys(credentialsTitles) as Credentials[];
